export const PROJECT_FETCH = 'PROJECT_FETCH'
export const PROJECT_SAVE = 'PROJECT_SAVE'
export const PROJECT_LOCK = 'PROJECT_LOCK'

export const PROJECT_PRIZES_FETCH = 'PROJECT_PRIZES_FETCH'
export const PROJECT_PRIZES_SET = 'PROJECT_PRIZES_SET'
export const PROJECT_PRIZES_ADD = 'PROJECT_PRIZES_ADD'
export const PROJECT_PRIZES_SAVE = 'PROJECT_PRIZES_SAVE'
export const PROJECT_PRIZES_REMOVE = 'PROJECT_PRIZES_REMOVE'

export const PROJECT_PRODUCTS_FETCH = 'PROJECT_PRODUCTS_FETCH'
export const PROJECT_PRODUCTS_SET = 'PROJECT_PRODUCTS_SET'
export const PROJECT_PRODUCTS_ADD = 'PROJECT_PRODUCTS_ADD'
export const PROJECT_PRODUCTS_SAVE = 'PROJECT_PRODUCTS_SAVE'
export const PROJECT_PRODUCTS_REMOVE = 'PROJECT_PRODUCTS_REMOVE'